// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"global-alert-message_wrapper__jG7z1"};